(() => {
  // app/scripts/common/component/cartNote.js
  var { fetch: fetch2, debounceTime } = theme;
  var CartNote = class extends HTMLElement {
    constructor() {
      super();
      const parent = this.closest(".cart-note-wrapper");
      this.querySelector("[name=note]")?.addEventListener("input", debounceTime((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch2(`${theme.routes.cartUrl}/update.js`, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": `application/json;`
          }
        });
      }, 1e3));
    }
  };
  customElements.define("cart-note", CartNote);

  // app/scripts/common/component/cartRemove.js
  var CartRemoveButton = class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector("a");
      link.addEventListener("click", (event) => {
        try {
          event.preventDefault();
          let { key, sections, sections_url } = link.dataset;
          if (!key)
            return;
          sections = [sections];
          this.closest("cart-component,cart-drawer-component").dispatchEvent(new CustomEvent("change", {
            bubbles: true,
            detail: {
              customElement: {
                target: link,
                key,
                quantity: 0,
                sections,
                sections_url
              }
            }
          }));
        } catch (e) {
          console.log(e);
        }
      });
    }
  };
  customElements.define("cart-remove-button", CartRemoveButton);

  // app/scripts/common/component/cartRecommendation.js
  var cartRecommendation = class extends HTMLElement {
    constructor() {
      super();
      this.limit = +this.dataset.limit;
      if (this.classList.contains("recommend-initialized")) {
        if (!this.querySelector(".jsSlideEl")?.slider) {
          setTimeout(() => {
            this.querySelector(".jsSlideEl")?.load();
          }, 100);
        }
      } else {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting)
            return;
          this.onLoad();
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this)).observe(this);
      }
    }
    onLoad() {
      if (!this.dataset.listId)
        return;
      this.dataset.listId ? this.fetchArray() : this.fetch();
    }
    fetch() {
      fetch(this.dataset.url).then((response) => response.text()).then((html) => {
        this.loaded(html);
      }).catch((e) => {
        console.error(e);
      });
    }
    fetchArray() {
      const arrayPromise = [];
      const listId = this.dataset.listId.split(",");
      listId.forEach((id) => {
        arrayPromise.push(new Promise((resolved) => {
          fetch(this.dataset.url.replace("PRODUCTID", id.trim())).then((response) => response.text()).then((html) => {
            resolved(html);
          });
        }));
      });
      Promise.all(arrayPromise).then((result) => {
        this.loaded(result.join(""));
      });
    }
    loaded(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      const itemList = div.querySelectorAll(".card");
      if (!itemList.length)
        return;
      const wrapper = this.querySelector(".js-recommend-items");
      [...itemList].slice(0, this.limit).forEach((item) => {
        wrapper.insertAdjacentElement("afterbegin", item);
      });
      this.querySelector(".js-container")?.classList.remove("hide");
      this.classList.add("recommend-initialized");
      this.querySelector(".jsSlideEl")?.load();
      this.closest(".js-popup")?.classList.add("cart-recommend-loaded");
    }
    removeExist() {
      this.querySelectorAll(".remove")?.forEach((item) => {
        item.remove();
      });
      return this.querySelectorAll(".product-card").length;
    }
  };
  customElements.define("cart-recommendation", cartRecommendation);

  // app/scripts/common/component/cartUpdateComponent.js
  !customElements.get("cart-update-component") && customElements.define("cart-update-component", class extends cartForm {
    constructor() {
      super();
      this.onChangeViewList();
      this.addEventListener("change", (e) => {
        this.currentTarget = e.target;
        let { value } = this.currentTarget;
        if (this.currentTarget.type == "checkbox") {
          value = this.currentTarget.checked;
        }
        this.onUpdate(value);
        if (this.querySelector(".jsValue")) {
          this.querySelector(".jsValue").innerHTML = value;
        }
        this.onDisplayViewList();
      });
      this.onResize();
    }
    onResize() {
      window.addEventListener("resize", () => {
        this.onDisplayViewList();
      });
    }
    onDisplayViewList() {
      if (window.matchMedia("(max-width: 749px)").matches) {
        this.querySelector(".total-show-list.mobile").style.display = "block";
        this.querySelector(".total-show-list.desktop").style.display = "none";
      } else {
        this.querySelector(".total-show-list.mobile").style.display = "none";
        this.querySelector(".total-show-list.desktop").style.display = "block";
      }
    }
    onChangeViewList() {
      if (window.matchMedia("(max-width: 749px)").matches) {
        this.querySelector(".total-show-list.mobile").style.display = "block";
        this.querySelector(".total-show-list.desktop").style.display = "none";
        const firstItem = this.querySelector(".total-show-list.mobile input.first");
      } else {
        this.querySelector(".total-show-list.mobile").style.display = "none";
        this.querySelector(".total-show-list.desktop").style.display = "block";
        const firstItem = this.querySelector(".total-show-list.desktop input.first");
      }
    }
    onUpdate(value) {
      const attributes = { [this.dataset.type]: value };
      this.disabled = true;
      this.cartUpdate(attributes);
    }
    set disabled(value) {
      this.classList.toggle("event-none", value);
    }
    async onFinished() {
      this.updateState();
      this.disabled = false;
    }
    async updateState() {
      const { sectionId } = this.dataset;
      if (!sectionId)
        return;
      let url = location.href;
      url += url.includes("?") ? "&" : "?";
      url += sectionId;
      let html = await fetch(url);
      html = await html.text();
      const div = document.createElement("div");
      div.innerHTML = html;
      this.closest("filter-component")?.render(div);
      if (this.currentTarget.closest("details[open]"))
        this.currentTarget.closest("details[open]").open = false;
    }
  });

  // app/scripts/cart-drawer-component.js
  var { debounceTime: debounceTime2 } = theme;
  var cartDrawerComponent = class extends cartForm {
    constructor() {
      super();
      const debounce = debounceTime2((e) => this.onChange(e), 300);
      this.addEventListener("change", debounce.bind(this));
    }
    set open(value) {
      const popup = this.closest("popup-component");
      if (value) {
        this.closeAllCurrentPopups();
        popup.open();
      } else
        popup.close();
    }
    set refresh(sections) {
      const div = document.createElement("div");
      div.innerHTML = sections[this.sectionName];
      this.innerHTML = div.querySelector(this.tagName).innerHTML;
    }
    closeAllCurrentPopups() {
      document.querySelectorAll("popup-component.active")?.forEach((popup) => {
        popup.close();
      });
    }
  };
  customElements.define("cart-drawer-component", cartDrawerComponent);
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".jsCartDrawer"))
      return;
    e.preventDefault();
    document.querySelector("cart-drawer-component").open = true;
  });
})();
